import { CommonDialogs } from "@mcleod/common";
import {
    BorderType,
    Button,
    ClickEvent,
    CrudDecorator,
    DataSourceMode, DataSourceModeChangeEvent,
    DropdownItem,
    EditRowDecorator,
    Image,
    ImageType,
    Label,
    LabelVariant,
    Layout,
    LayoutProps,
    Panel,
    RepeatItemDisplayEvent,
    SaveButton,
    Snackbar,
    Switch
} from "@mcleod/components";
import { RepeatItem } from "@mcleod/components/src/components/repeater/RepeatItem";
import { CrudDecoratorProps } from "@mcleod/components/src/page/decorators/CrudDecoratorProps";
import { Alignment, Api, ModelRow, Navigation, StringUtil, UrlUtil, VerticalAlignment } from "@mcleod/core";
import { MobileCommControlTabView } from "@mcleod/dispatch/src/mobilecomm/MobileCommControlTabView";
import { LoadBoardTruckSearchSlideout } from "@mcleod/general/src/LoadBoardTruckSearchSlideout";
import { PbwLoadboardServicesSlideout } from "@mcleod/general/src/PbwLoadboardServicesSlideout";
import { ImageName } from "@mcleod/images";
import { AutogenLayoutIntegrationHub } from "@mcleod/integrations/src/autogen/AutogenLayoutIntegrationHub";
import { FuelFundedVendorDefaults } from "@mcleod/integrations/src/fuel/FuelFundedVendorDefaults";
import { DatControl } from "@mcleod/powerbroker/src/DatControl";
import { DistanceSource } from "@mcleod/powerbroker/src/DistanceSource";
import { FourKitesControl } from "@mcleod/powerbroker/src/FourKitesControl";
import { FreightMatchingControl } from "@mcleod/powerbroker/src/FreightMatchingControl";
import { GreenscreensControl } from "@mcleod/powerbroker/src/GreenscreensControl";
import { CarrierConnectControl } from "@mcleod/powerbroker/src/ltl/CarrierConnectControl";
import { P44Control } from "@mcleod/powerbroker/src/ltl/P44Control";
import { RatewareControl } from "@mcleod/powerbroker/src/ltl/RatewareControl";
import { Smc3Control } from "@mcleod/powerbroker/src/ltl/Smc3Control";
import { MacroPointDataExportControl } from "@mcleod/powerbroker/src/MacroPointDataExportControl";
import { MappingVendors } from "@mcleod/powerbroker/src/MappingVendors";
import { MpactControl } from "@mcleod/powerbroker/src/MpactControl";
import { RateIndexControlPanel } from "@mcleod/powerbroker/src/RateIndexControlPanel";
import { SaferWatchControl } from "@mcleod/powerbroker/src/SaferWatchControl";
import { ScoreCardControl } from "@mcleod/powerbroker/src/ScoreCardControl";
import { BrokerageTrackingControlPanel } from "@mcleod/powerbroker/src/tracking/BrokerageTrackingControlPanel";
import { TrimbleVisibilityDataExportControl } from "@mcleod/powerbroker/src/TrimbleVisibilityDataExportControl";
import {TruckSearch} from "./loadboard/TruckSearch";

enum RateIndexControlVendor { EXCHANGE = "E", DAT_TRANSCORE = "T", TRUCKSTOP = "I", FREIGHTWAVES = "F", GREENSCREENS = "G" }
enum BrokerageTrackingControlVendor { MACROPOINT = "M", PROJECT44 = "P", TRUCKER_TOOLS = "L", FOURKITES = "F" }
enum CarrierMonitoringControlVendor { CARRIERWATCH = "C", SAFERWATCH = "S", HIGHWAY = "H", RMIS = "R", ASSURE_ADVANTAGE = "D" }
enum MappingVendor { GOOGLE = "G", TRIMBLE = "W" }
enum DataExport { MACROPOINT = "M", FOURKITES = "F", TRIMBLE_VISIBILITY = "T" }
enum DistanceServer { PC_MILER_WEB = "T", MILEMAKER = "E", PC_MILER_ON_PREM = "A" }
enum CarrierScoreCardVendor { ISO = "I" }
enum LTL { SMC3 = "SLA", P44 = "P44", RATEWARE = "RW", CARRIER_CONNECT = "CC" }
enum LoadBoardService { TRUCKSTOP = "R", CONNEXION = "C", JSON = "J", DAT = "D", TRUCKSTOP_SEARCH = "T", DAT_REST = "T" }
enum OpenSliderFrom {
    RATE_INDEX = "Rate Index",
    BROKERAGE_TRACKING = "Brokerage Tracking",
    CARRIER_MONITORING = "Carrier Monitoring",
    MAPPING_VENDOR = "Mapping Vendor",
    CARRIER_PERFORMANCE = "Carrier Performance",
    DAT = "DAT",
    GREENSCREENS = "GREENSCREENS",
    MPACT = "MPact Control",
    P44 = "P44",
    SMC3 = "SMC3",
    RATEWARE_XL = "RW",
    CARRIER_CONNECT = "CC",
    LOADBOARD_SERVICE = "Load Board Service",
    LOADBOARD_SERVICE_SEARCH = "Load Board Service Search",
    DATA_EXPORT = "Data Export",
    DISTANCE_SERVER = "Distance Server",
    MOBILE_COMMUNICATION_AND_HOS_SERVICE = "Mobile Communication and HOS Service",
    TEMPERATURE_AND_TRAILER_TRACKING = "Trailer and Temperature Tracking",
    FREIGHT_MATCHING = "Freight Matching",
    FUEL_SERVICES = "Fuel Services"
}

enum SliderTitle {
    MPACT = "MPact Control",
    TRUCKSTOP_CONTROL = "Truckstop Control",
    TRUCKSTOP_SEARCH = "Truckstop Truck Search",
    RATE_INDEX_FREIGHTWAVES = "SONAR Control",
    GREENSCREEN_CONTROL = "Greenscreens Control",
    BR_TRACKING_MACROPOINT = "MacroPoint Control",
    BR_TRACKING_PROJECT44 = "Project44 Control",
    BR_TRACKING_TRUCKER_TOOLS = "Trucker Tools Control",
    BR_TRACKING_FOURKITES = "FourKites Control",
    CARRIER_MONITORING_CARRIER_WATCH = "CarrierWatch Control",
    DATA_EXPORT_MACROPOINT = "MacroPoint Export Control",
    DATA_EXPORT_TRIMBLE_VISIBILITY = "Trimble Visibility Export Control",
    DATA_EXPORT_FOURKITES = "Fourkites Export Control",
    SAFERWATCH_CONTROL = "SaferWatch Control",
    HIGHWAY_CONTROL = "Highway Control",
    RMIS_CONTROL = "RMIS Control",
    ASSURE_ADVANTAGE_CONTROL = "MyCarrierPortal Control",
    SMS_CONTROL = "SMS Control",
    SCORECARD_CONTROL = "ISO Control",
    DAT_CONTROL = "DAT Control",
    JSON_CONTROL = "Json Control",
    MAPPING_VENDOR_GOOGLE = "Google Mapping",
    MAPPING_VENDOR_TRIMBLE = "Trimble Mapping",
    DISTANCE_SERVER_MILEMAKER = "MileMaker",
    DISTANCE_SERVER_PCMILER = "PC*Miler",
    P44_CONTROL = "P44 Rating Interface Control",
    SMC3_CONTROL = "SMC3 Rating Interface Control",
    RATEWARE_CONTROL = "RateWare-XL Interface Control",
    CARRIER_CONNECT_CONTROL = "Carrier Connect Interface Control",
    LOAD_BOARD_SERVICE_CONTROL = "Load Board Service Control",
    MOBILE_COMMUNICATION_CONTROL = "Mobile Comm Control",
    FREIGHT_MATCHING_CONTROL = "Freight Matching Control",
    TRIUMPH_PAY = "Triumph Pay Control",
    TRIUMPH_PAY_AUDIT = "Triumph Pay Audit Control",
    FUEL_CONTROL = "Fuel Services Provider Control",
}

enum Categories{
    PAYMENT_CATEGORY = "Carrier Invoices & Payments",
    FUEL_CATEGORY = "Fuel",
    SMS_CATEGORY = "Messaging & Communications",
    BENCHMARK_REPORTS_CATEGORY = "Benchmarking & Analysis",
    lOADBOARD_CATEGORY = "Load Board Services"
}

interface controlLayoutProps extends LayoutProps {
    vendorId: string;
}

export class IntegrationHub extends AutogenLayoutIntegrationHub {
    private descriptionName = null;
    private currentLabelHeader: string;
    private clickedRepeatItem: RepeatItem;
    private mobileCommHOSSwitch: Switch = null;
    private mobileCommTrackingSwitch: Switch = null;
    private mobileCommItems: RepeatItem[] = [];
    private mobileCommTrackingItems: RepeatItem[] = [];
    private configureTimeoutId: any = null;
    private slideoutOpening: boolean = false;
    private saveButtonClicked: boolean = false;

    private sliderConfiguration = {
        1: { vendorId: RateIndexControlVendor.DAT_TRANSCORE, title: SliderTitle.DAT_CONTROL, openFrom: OpenSliderFrom.DAT },
        2: { vendorId: RateIndexControlVendor.FREIGHTWAVES, title: SliderTitle.RATE_INDEX_FREIGHTWAVES, openFrom: OpenSliderFrom.RATE_INDEX },
        3: { vendorId: RateIndexControlVendor.GREENSCREENS, title: SliderTitle.GREENSCREEN_CONTROL, openFrom: OpenSliderFrom.GREENSCREENS },
        4: { vendorId: RateIndexControlVendor.TRUCKSTOP, title: SliderTitle.TRUCKSTOP_CONTROL, openFrom: OpenSliderFrom.RATE_INDEX },
        5: { vendorId: RateIndexControlVendor.EXCHANGE, title: SliderTitle.MPACT, openFrom: OpenSliderFrom.MPACT },
        6: { vendorId: BrokerageTrackingControlVendor.MACROPOINT, title: SliderTitle.BR_TRACKING_MACROPOINT, openFrom: OpenSliderFrom.BROKERAGE_TRACKING },
        7: { vendorId: BrokerageTrackingControlVendor.FOURKITES, title: SliderTitle.BR_TRACKING_FOURKITES, openFrom: OpenSliderFrom.BROKERAGE_TRACKING },
        8: { vendorId: BrokerageTrackingControlVendor.PROJECT44, title: SliderTitle.BR_TRACKING_PROJECT44, openFrom: OpenSliderFrom.BROKERAGE_TRACKING },
        9: { vendorId: BrokerageTrackingControlVendor.TRUCKER_TOOLS, title: SliderTitle.BR_TRACKING_TRUCKER_TOOLS, openFrom: OpenSliderFrom.BROKERAGE_TRACKING },
        10: { vendorId: CarrierMonitoringControlVendor.CARRIERWATCH, title: SliderTitle.CARRIER_MONITORING_CARRIER_WATCH, openFrom: OpenSliderFrom.CARRIER_MONITORING },
        11: { vendorId: CarrierMonitoringControlVendor.SAFERWATCH, title: SliderTitle.SAFERWATCH_CONTROL, openFrom: OpenSliderFrom.CARRIER_MONITORING },
        12: { vendorId: CarrierMonitoringControlVendor.HIGHWAY, title: SliderTitle.HIGHWAY_CONTROL, openFrom: OpenSliderFrom.CARRIER_MONITORING },
        13: { vendorId: CarrierMonitoringControlVendor.RMIS, title: SliderTitle.RMIS_CONTROL, openFrom: OpenSliderFrom.CARRIER_MONITORING },
        14: { vendorId: CarrierMonitoringControlVendor.ASSURE_ADVANTAGE, title: SliderTitle.ASSURE_ADVANTAGE_CONTROL, openFrom: OpenSliderFrom.CARRIER_MONITORING },
        16: { vendorId: DataExport.MACROPOINT, sliderTitle: SliderTitle.DATA_EXPORT_MACROPOINT, sliderFrom: OpenSliderFrom.DATA_EXPORT, isSingleton: true, childSection: "Macropoint" },
        17: { vendorId: DataExport.TRIMBLE_VISIBILITY, sliderTitle: SliderTitle.DATA_EXPORT_TRIMBLE_VISIBILITY, sliderFrom: OpenSliderFrom.DATA_EXPORT, isSingleton: true, childSection: "Trimble" },
        18: { vendorId: DataExport.FOURKITES, sliderTitle: SliderTitle.DATA_EXPORT_FOURKITES, sliderFrom: OpenSliderFrom.DATA_EXPORT, isSingleton: true, childSection: "Fourkites" },
        19: { vendorId: CarrierScoreCardVendor.ISO, title: SliderTitle.SCORECARD_CONTROL, openFrom: OpenSliderFrom.CARRIER_PERFORMANCE },
        20: { vendorId: MappingVendor.GOOGLE, sliderTitle: SliderTitle.MAPPING_VENDOR_GOOGLE, sliderFrom: OpenSliderFrom.MAPPING_VENDOR, isSingleton: false },
        21: { vendorId: MappingVendor.TRIMBLE, sliderTitle: SliderTitle.MAPPING_VENDOR_TRIMBLE, sliderFrom: OpenSliderFrom.MAPPING_VENDOR, isSingleton: false },
        22: { vendorId: DistanceServer.PC_MILER_WEB, sliderTitle: SliderTitle.DISTANCE_SERVER_PCMILER, sliderFrom: OpenSliderFrom.DISTANCE_SERVER, isSingleton: false },
        23: { vendorId: DistanceServer.MILEMAKER, sliderTitle: SliderTitle.DISTANCE_SERVER_MILEMAKER, sliderFrom: OpenSliderFrom.DISTANCE_SERVER, isSingleton: false },
        24: { vendorId: LTL.P44, title: SliderTitle.P44_CONTROL, openFrom: OpenSliderFrom.P44 },
        25: { vendorId: LTL.SMC3, title: SliderTitle.SMC3_CONTROL, openFrom: OpenSliderFrom.SMC3 },
        26: { vendorId: LTL.RATEWARE, title: SliderTitle.RATEWARE_CONTROL, openFrom: OpenSliderFrom.RATEWARE_XL },
        27: { vendorId: LTL.CARRIER_CONNECT, title: SliderTitle.CARRIER_CONNECT_CONTROL, openFrom: OpenSliderFrom.CARRIER_CONNECT },
        28: { vendorId: LoadBoardService.TRUCKSTOP, title: SliderTitle.TRUCKSTOP_CONTROL, openFrom: OpenSliderFrom.LOADBOARD_SERVICE },
        29: { vendorId: LoadBoardService.CONNEXION, title: SliderTitle.DAT_CONTROL, openFrom: OpenSliderFrom.LOADBOARD_SERVICE },
        30: { vendorId: LoadBoardService.JSON, title: SliderTitle.JSON_CONTROL, openFrom: OpenSliderFrom.LOADBOARD_SERVICE },
        31: { vendorId: LoadBoardService.DAT, title: SliderTitle.DAT_CONTROL, openFrom: OpenSliderFrom.LOADBOARD_SERVICE },
        32: { vendorId: "", title: SliderTitle.LOAD_BOARD_SERVICE_CONTROL, openFrom: OpenSliderFrom.LOADBOARD_SERVICE },
        33: { vendorId: LoadBoardService.TRUCKSTOP_SEARCH, title: SliderTitle.TRUCKSTOP_SEARCH, openFrom: OpenSliderFrom.LOADBOARD_SERVICE_SEARCH },
        34: { vendorId: LoadBoardService.DAT_REST, title: SliderTitle.DAT_CONTROL, openFrom: OpenSliderFrom.LOADBOARD_SERVICE },
        35: { vendorId: "", title: SliderTitle.MOBILE_COMMUNICATION_CONTROL, openFrom: OpenSliderFrom.MOBILE_COMMUNICATION_AND_HOS_SERVICE },
        36: { vendorId: "", title: SliderTitle.MOBILE_COMMUNICATION_CONTROL, openFrom: OpenSliderFrom.TEMPERATURE_AND_TRAILER_TRACKING },
        37: { vendorId: "", title: SliderTitle.FREIGHT_MATCHING_CONTROL, openFrom: OpenSliderFrom.FREIGHT_MATCHING },
        // WARNING!!! 38 and 39 are being used for the the CRUD decorator. New tiles will need to be added ModelIntegrationPartnerList when using this approach
    };

    private monitoringMap: Record<string, string> = {
        "D": "lme/powerbroker/AssureAdvantageControl",
        "C": "lme/powerbroker/CarrierWatchControl",
        "H": "lme/powerbroker/HighwayControl",
        "R": "lme/powerbroker/RmisControl",
        "S": "lme/powerbroker/SaferWatchControl"
    };


    setupSingleControlLayout(vendorId: string, title: string, sliderFrom: string, isSingletonControl: boolean, childSection?: string) {
        const layout = this.getLayoutFromUI(sliderFrom, childSection);
        if (layout == null) {
            Snackbar.showWarningSnackbar("Unable to Find the Layout for " + title);
            return;
        }
        const saveButton = SaveButton.create({
            id: "saveBtn",
            rowBreak: false,
            caption: "Save & Close",
            color: "McLeodWhite",
            backgroundColor: "primary",
            borderWidth: 0,
            dataSource: this.mainDataSource,
            onClick: async () => {
                if (OpenSliderFrom.DATA_EXPORT === sliderFrom && "Fourkites" === childSection) {
                    layout.slideOut();
                } else {
                    const response = OpenSliderFrom.LOADBOARD_SERVICE === sliderFrom ? await layout.postDataSources(vendorId) : await layout.postDataSources(vendorId);
                    if (response) {
                        layout.slideOut();
                    }
                }
            }
        });

        const editRowDecorator = new EditRowDecorator({
            title: title,
            layout: layout,
            fillVerticalSpace: true,
            width: 1250,
            overlayProps: {
                greyedBackground: true,
                closeOnClickOff: false,
                closeHandler: async () => {
                    this.validateUnSaveChanges(layout)
                }
            },
            layoutLoadListeners: async () => {
                if (isSingletonControl) {
                    layout.mainDataSource.addAfterExecutionListener(() => {
                        if (layout.activeRow == null) {
                            editRowDecorator.dataSourceMode = layout.mainDataSource.mode = DataSourceMode.ADD;
                        } else {
                            editRowDecorator.dataSourceMode = layout.mainDataSource.mode = DataSourceMode.UPDATE;
                        }
                    });
                } else {
                    let response: any;
                    if (layout instanceof DistanceSource) {
                        response = await layout.mainDataSource.search({ "id": vendorId });
                        this.createDropdownItemsDistanceSource(layout, vendorId);
                        this.createDropdownItems(layout);
                    } else {
                        response = await layout.mainDataSource.search({ "vendor": vendorId });
                    }
                    if (response.modelRows.length > 0) {
                        const data = response.modelRows[0].data;
                        if (layout instanceof MappingVendors) {
                            response = await Api.search("lme/powerbroker/web-control-license");
                            this.setActiveRowForMappingVendors(data, layout, response, vendorId);
                        } else if (layout instanceof DistanceSource) {
                            await Api.search("lme/powerbroker/web-control-license");
                            if (DistanceServer.PC_MILER_WEB === vendorId || DistanceServer.PC_MILER_ON_PREM === vendorId) {
                                await layout.sourceDistanceSource.search({ "id": vendorId });
                            }
                            this.setActiveRowForDistanceServer(layout, vendorId);
                        }
                        editRowDecorator.dataSourceMode = layout.mainDataSource.mode = DataSourceMode.UPDATE;
                    } else {
                        this.setTrimbleGooglePanelVisibility(vendorId, layout);
                        editRowDecorator.dataSourceMode = layout.mainDataSource.mode = DataSourceMode.ADD;
                    }

                }
            },
            doAfterSlideIn: async () => {
                // Need to remove the dataSource from the SaveButton so that its' performPost() does not actually work.  We need to leave
                // the posting to the layout
                saveButton.dataSource = null;
                if (layout.mainDataSource.mode === DataSourceMode.UPDATE || layout.mainDataSource.mode === DataSourceMode.NONE) {
                    layout.mainDataSource.addHasChangedComponent(saveButton);
                    if (OpenSliderFrom.MAPPING_VENDOR === sliderFrom) {
                        this.setMappingSourceMode(layout, saveButton, DataSourceMode.UPDATE);
                    }
                } else if (layout.mainDataSource.mode === DataSourceMode.ADD) {
                    // Enable the Save button
                    saveButton.enabled = true;
                    if (OpenSliderFrom.MAPPING_VENDOR === sliderFrom) {
                        this.setMappingSourceMode(layout, saveButton, DataSourceMode.ADD);
                    }
                }
            },
            doAfterSlideOut: () => {
                if (OpenSliderFrom.MAPPING_VENDOR === sliderFrom) {
                    const dataSourceVendorId = layout.mainDataSource.activeRow?.data.vendor;
                    const vendorExists = vendorId === dataSourceVendorId;
                    this.updateIsActiveImage(this.clickedRepeatItem, vendorExists)
                } else if (OpenSliderFrom.DISTANCE_SERVER === sliderFrom) {
                    const vendorExists = layout.mainDataSource.activeRow?.data.id !== undefined;
                    this.updateIsActiveImage(this.clickedRepeatItem, vendorExists)
                } else if (OpenSliderFrom.DATA_EXPORT === sliderFrom) {
                    const vendorExists = layout.mainDataSource.activeRow?.data?.is_active === "Y";
                    this.updateIsActiveImage(this.clickedRepeatItem, vendorExists)
                }
            },
            addlComponents: saveButton,
            onClose: () => {
                this.validateUnSaveChanges(layout)
            },
        });
    }

    private setMappingSourceMode(layout: any, saveButton: SaveButton, mode: DataSourceMode) {
        layout.sourceMappingControl.mode = mode;
        layout.sourceDispatchControl.mode = mode;
        layout.sourceMappingControl.addHasChangedComponent(saveButton);
        layout.sourceDispatchControl.addHasChangedComponent(saveButton);
    }

    private getLayoutFromUI(sliderFrom: string, childSection: string) {
        let layout = null;
        if (OpenSliderFrom.DATA_EXPORT === sliderFrom && "Macropoint" === childSection) {
            layout = Layout.getLayout("lme/powerbroker/MacroPointDataExportControl") as MacroPointDataExportControl;
        } else if (OpenSliderFrom.DATA_EXPORT === sliderFrom && "Trimble" === childSection) {
            layout = Layout.getLayout("lme/powerbroker/TrimbleVisibilityDataExportControl") as TrimbleVisibilityDataExportControl;
        } else if (OpenSliderFrom.DATA_EXPORT === sliderFrom && "Fourkites" === childSection) {
            layout = Layout.getLayout("lme/powerbroker/FourKitesControl") as FourKitesControl;
        } else if (OpenSliderFrom.MAPPING_VENDOR === sliderFrom) {
            layout = Layout.getLayout("lme/powerbroker/MappingVendors") as MappingVendors;
        } else if (OpenSliderFrom.DISTANCE_SERVER === sliderFrom) {
            layout = Layout.getLayout("lme/powerbroker/DistanceSource") as DistanceSource;
        } else if (OpenSliderFrom.MOBILE_COMMUNICATION_AND_HOS_SERVICE === sliderFrom) {
            layout = Layout.getLayout("lme/dispatch/mobilecomm/MobileCommControlTabView") as MobileCommControlTabView;
        } else if (OpenSliderFrom.TEMPERATURE_AND_TRAILER_TRACKING === sliderFrom) {
            layout = Layout.getLayout("lme/dispatch/mobilecomm/MobileCommControlTabView") as MobileCommControlTabView;
        }
        return layout;
    }

    private createDropdownItemsDistanceSource(layout: DistanceSource, vendorId: string) {
        const options: DropdownItem[] = [];
        if (DistanceServer.PC_MILER_WEB === vendorId || DistanceServer.PC_MILER_ON_PREM === vendorId) {
            const webServices = new DropdownItem(DistanceServer.PC_MILER_WEB, "PC*Miler - Web Services");
            const onPrem = new DropdownItem(DistanceServer.PC_MILER_ON_PREM, "PC*Miler - On Prem");
            options.push(webServices);
            options.push(onPrem);
            layout.textboxDistanceVendorOptions.items = options;
            layout.textboxDistanceVendorOptions.selectedItem = vendorId === DistanceServer.PC_MILER_WEB ? webServices : onPrem;
        } else if ("E" === vendorId) {
            const webServices = new DropdownItem("E", "MileMaker");
            const onPrem = new DropdownItem("R", "Intelliroute");
            options.push(webServices);
            options.push(onPrem);
            layout.textboxDistanceVendorOptions.items = options;
            layout.textboxDistanceVendorOptions.selectedItem = webServices;
        }
    }

    private createDropdownItems(layout: DistanceSource) {
        const options: DropdownItem[] = [];
        options.push(new DropdownItem("B", "Both"));
        options.push(new DropdownItem("A", "Add Cities Only"));
        options.push(new DropdownItem("I", "Inactive Cities Only"));
        layout.textboxUpdateType.items = options;
        layout.textboxUpdateType.selectedItem = new DropdownItem("A", "Add Cities Only");
    }


    private setActiveRowForDistanceServer(layout: DistanceSource, vendorId: string) {
        const isPCMiler = DistanceServer.PC_MILER_WEB === vendorId || DistanceServer.PC_MILER_ON_PREM === vendorId;
        layout.panelTrimble.visible = isPCMiler;
        layout.panelTrimble.visibleDuringAdd = isPCMiler;
        layout.panelTrimble.visibleDuringUpdate = isPCMiler;
    }

    private async setActiveRowForMappingVendors(data: any, layout: MappingVendors, response: any, vendorId: string) {
        this.setTrimbleGooglePanelVisibility(vendorId, layout);
        const mapView = data.map_view;
        if (mapView === undefined || mapView === null) {
            layout.activeRow.set("map_view", "M");
        }
        const hasLicense: boolean = response?.data[0]?.has_license;
        if (hasLicense) {
            const wwwApiKey = layout.sourceWwwControl.activeRow?.get("google_api_key_web");
            if (wwwApiKey) {
                const truncatedApiKey = wwwApiKey.length > 10 ? wwwApiKey.slice(0, 10) + '...' : wwwApiKey;
                layout.sourceWwwControl.activeRow.set("google_api_key_web", truncatedApiKey);
                layout.textboxWebApiKey.visible = true;
            }
            else {
                layout.textboxWebApiKey.visible = false;
            }
        } else {
            layout.textboxWebApiKey.visible = false;
        }
    }

    private setTrimbleGooglePanelVisibility(vendorId: string, layout: MappingVendors) {
        if (MappingVendor.TRIMBLE === vendorId) {
            layout.panelTrimble.visible = true;
            layout.panelTrimble.visibleDuringAdd = true;
            layout.panelTrimble.visibleDuringUpdate = true;
            layout.panelGoogle.visible = false;
            layout.panelGoogle.visibleDuringAdd = false;
            layout.panelGoogle.visibleDuringUpdate = false;
        } else if (MappingVendor.GOOGLE === vendorId) {
            layout.panelTrimble.visible = false;
            layout.panelTrimble.visibleDuringAdd = false;
            layout.panelTrimble.visibleDuringUpdate = false;
            layout.panelGoogle.visible = true;
            layout.panelGoogle.visibleDuringAdd = true;
            layout.panelGoogle.visibleDuringUpdate = true;
            layout.textboxWebApiKey.visible = false;
        }
    }

    private setDataListItemVisibility(dataListItem: RepeatItem) {
        const partnerType = dataListItem.boundRow?.get("mobile_comm_type");

        if (this.isMobileCommPartner(partnerType)) {
            const isActive = dataListItem.boundRow?.get("is_active");
            const actualVendorId = dataListItem.boundRow?.get("actual_vendor_id");
            dataListItem.visible = this.shouldShowMobileCommItem(isActive, actualVendorId);
        }
    }

    private isMobileCommPartner(partnerType: string): boolean {
        return partnerType === "MC_HOS_TYPE" || partnerType === "MC_TRACKING_TYPE";
    }

    private shouldShowMobileCommItem(isActive: boolean, actualVendorId: string): boolean {
        return isActive || StringUtil.isEmptyString(actualVendorId);
    }

    private handleMobileCommSwitchToggle(category: string, showActiveOnly: boolean) {
        const itemsContainer = this.findComponentById(`items-container-${category}`) as Panel;
        if (!itemsContainer) return;

        this.updateMobileCommItemsVisibility(itemsContainer, showActiveOnly);
    }

    private updateMobileCommItemsVisibility(itemsContainer: Panel, showActiveOnly: boolean) {
        for (const component of itemsContainer.components) {
            if (this.isRepeatItem(component)) {
                const actualVendorId = component.boundRow?.get("actual_vendor_id");
                const isActive = component.boundRow?.data?.is_active === "Y" || component.boundRow?.data?.is_active === true;
                component.visible = this.shouldShowItem(showActiveOnly, isActive) || StringUtil.isEmptyString(actualVendorId);
            }
        }
    }

    private isRepeatItem(component: any): component is RepeatItem {
        return component instanceof RepeatItem;
    }

    private shouldShowItem(showActiveOnly: boolean, isActive: boolean): boolean {
        return showActiveOnly ? isActive : true;
    }

    private configureMobileCommSwitch(mobileCommSwitch: Switch, mobileCommItems: RepeatItem[], itemsContainer: Panel) {
        if (!mobileCommSwitch || mobileCommItems.length === 0) {
            return;
        }

        // Check if any mobile comm items are active
        const hasActiveItems = mobileCommItems.some(item => {
            const isActive = item.boundRow?.data?.is_active === "Y" || item.boundRow?.data?.is_active === true;
            return isActive;
        });

        // Set switch state: checked if there are active items, unchecked if none are active
        mobileCommSwitch.checked = hasActiveItems;

        // Update visibility of all mobile comm items based on the switch state
        if (itemsContainer) {
            this.updateMobileCommItemsVisibility(itemsContainer, hasActiveItems);
        }
    }

    async validateUnSaveChanges(layout: any) {
        if (layout.mainDataSource.mode == DataSourceMode.ADD) {
            layout.slideOut();
            return;
        }
        if (layout instanceof FourKitesControl) {
            layout.slideOut();
            return;
        }
        if (layout instanceof DatControl || layout instanceof GreenscreensControl) {
            if (!layout.mainDataSource.hasChanged() && !layout.sourceMarketrateExprt.hasChanged()) {
                layout.slideOut();
                return;
            }
        } else if (layout instanceof MpactControl) {
            const changedData = layout.sourceMarketrateExprt.activeRow.getChangedData() as Partial<any>;
            const activeRow = layout.sourceMarketrateExprt.activeRow;
            const isMarketRateExprtChanged = Object.keys(changedData).length > 0 && !activeRow.isDataEqual(changedData);
            if (!layout.mainDataSource.hasChanged() && !isMarketRateExprtChanged && !layout.sourceExchangeControl.hasChanged()) {
                layout.slideOut();
                return;
            }
        } else if (layout instanceof MappingVendors) {
            if (!layout.mainDataSource.hasChanged() && !layout.sourceDispatchControl.hasChanged() && !layout.sourceMappingControl.hasChanged()) {
                layout.slideOut();
                return;
            }
        } else if (!layout.mainDataSource.hasChanged()) {
            layout.slideOut();
            return;
        }
        const message = "Unsaved changes are present.  Do you wish to leave without saving changes?";
        const dialogProps = {
            yesButtonCaption: "Leave",
            noButtonCaption: "Stay"
        };
        const leave = await CommonDialogs.showYesNo(message, "Leave Without Saving?", dialogProps);
        if (leave !== true)
            return;
        layout.slideOut();
    }

    getLayout(sliderFrom: OpenSliderFrom, vendorId: string, childSection: string) {
        const layoutProps: Partial<controlLayoutProps> = { vendorId: vendorId };
        const layoutMap: Record<OpenSliderFrom, any> = {
            [OpenSliderFrom.BROKERAGE_TRACKING]: Layout.getLayout("lme/powerbroker/tracking/BrokerageTrackingControlPanel", layoutProps) as BrokerageTrackingControlPanel,
            [OpenSliderFrom.CARRIER_MONITORING]: Layout.getLayout(this.monitoringMap[vendorId], layoutProps) as SaferWatchControl,
            [OpenSliderFrom.RATE_INDEX]: Layout.getLayout("lme/powerbroker/RateIndexControlPanel", layoutProps) as RateIndexControlPanel,
            [OpenSliderFrom.CARRIER_PERFORMANCE]: Layout.getLayout("lme/powerbroker/ScoreCardControl", layoutProps) as ScoreCardControl,
            [OpenSliderFrom.MAPPING_VENDOR]: Layout.getLayout("lme/powerbroker/MappingVendors", layoutProps) as MappingVendors,
            [OpenSliderFrom.DAT]: Layout.getLayout("lme/powerbroker/DatControl", layoutProps) as DatControl,
            [OpenSliderFrom.GREENSCREENS]: Layout.getLayout("lme/powerbroker/GreenscreensControl", layoutProps) as GreenscreensControl,
            [OpenSliderFrom.MPACT]: Layout.getLayout("lme/powerbroker/MpactControl", layoutProps) as MpactControl,
            [OpenSliderFrom.P44]: Layout.getLayout("lme/powerbroker/ltl/P44Control", layoutProps) as P44Control,
            [OpenSliderFrom.SMC3]: Layout.getLayout("lme/powerbroker/ltl/Smc3Control", layoutProps) as Smc3Control,
            [OpenSliderFrom.RATEWARE_XL]: Layout.getLayout("lme/powerbroker/ltl/RatewareControl", layoutProps) as RatewareControl,
            [OpenSliderFrom.CARRIER_CONNECT]: Layout.getLayout("lme/powerbroker/ltl/CarrierConnectControl", layoutProps) as CarrierConnectControl,
            [OpenSliderFrom.LOADBOARD_SERVICE]: Layout.getLayout("lme/general/PbwLoadboardServicesSlideout", layoutProps) as PbwLoadboardServicesSlideout,
            [OpenSliderFrom.LOADBOARD_SERVICE_SEARCH]: Layout.getLayout("lme/integrations/loadboard/TruckSearch", layoutProps) as TruckSearch,
            [OpenSliderFrom.DATA_EXPORT]: this.getLayoutFromUI(sliderFrom, childSection),
            [OpenSliderFrom.DISTANCE_SERVER]: this.getLayoutFromUI(sliderFrom, childSection),
            [OpenSliderFrom.MOBILE_COMMUNICATION_AND_HOS_SERVICE]: this.getLayoutFromUI(sliderFrom, childSection),
            [OpenSliderFrom.TEMPERATURE_AND_TRAILER_TRACKING]: this.getLayoutFromUI(sliderFrom, childSection),
            [OpenSliderFrom.FREIGHT_MATCHING]: Layout.getLayout("lme/powerbroker/FreightMatchingControl", layoutProps) as FreightMatchingControl,
            [OpenSliderFrom.FUEL_SERVICES]: Layout.getLayout("lme/integrations/fuel/FuelFundedVendorDefaults", layoutProps) as FuelFundedVendorDefaults,
        };
        return layoutMap[sliderFrom];
    }

    setUpControlLayout(vendorId: string, title: string, sliderFrom: OpenSliderFrom, childSection?: string, dataListItem?: RepeatItem) {
        const layout = this.getLayout(sliderFrom, vendorId, childSection);

        if (layout == null) {
            Snackbar.showWarningSnackbar("Unable to Find the Layout for " + title);
            return;
        }

        layout.addLayoutLoadListener(async () => {
            const saveButton = SaveButton.create({
                id: "saveBtn",
                rowBreak: false,
                caption: "Save & Close",
                color: "McLeodWhite",
                backgroundColor: "primary",
                borderWidth: 0,
                dataSource: this.mainDataSource,
                onClick: async () => {
                    saveButton.busy = true;
                    const response = (OpenSliderFrom.LOADBOARD_SERVICE === sliderFrom
                        || OpenSliderFrom.MOBILE_COMMUNICATION_AND_HOS_SERVICE === sliderFrom
                        || OpenSliderFrom.TEMPERATURE_AND_TRAILER_TRACKING === sliderFrom
                        || OpenSliderFrom.FREIGHT_MATCHING === sliderFrom)
                        ? await layout.postDataSources() : await layout.postDataSources(vendorId);
                    if (response) {
                        if (OpenSliderFrom.MOBILE_COMMUNICATION_AND_HOS_SERVICE != sliderFrom && OpenSliderFrom.TEMPERATURE_AND_TRAILER_TRACKING != sliderFrom) {
                            await layout.slideOut();
                        }

                        // logic to refresh the screen to display the newly added load board service/mobile comm record.
                        if ((OpenSliderFrom.LOADBOARD_SERVICE === sliderFrom
                                || OpenSliderFrom.MOBILE_COMMUNICATION_AND_HOS_SERVICE === sliderFrom
                                || OpenSliderFrom.TEMPERATURE_AND_TRAILER_TRACKING === sliderFrom)
                            && StringUtil.isEmptyString(vendorId)) {
                            Navigation.reloadCurrentPage(false);
                        }

                        const isActiveVendor = layout.mainDataSource.activeRow?.data?.is_active === "Y";
                        if (([OpenSliderFrom.P44, OpenSliderFrom.SMC3, OpenSliderFrom.RATEWARE_XL, OpenSliderFrom.CARRIER_CONNECT,
                            OpenSliderFrom.BROKERAGE_TRACKING, OpenSliderFrom.CARRIER_PERFORMANCE, //OpenSliderFrom.SMS,
                            OpenSliderFrom.LOADBOARD_SERVICE] as OpenSliderFrom[]).includes(sliderFrom)) {
                            this.updateIsActiveImage(this.clickedRepeatItem, isActiveVendor);
                            this.updatePanelDesc(this.clickedRepeatItem, layout.mainDataSource.activeRow?.data?.description);
                        } else if (OpenSliderFrom.LOADBOARD_SERVICE_SEARCH === sliderFrom && this.clickedRepeatItem) {
                            this.updateIsActiveImage(this.clickedRepeatItem, isActiveVendor);
                            this.updatePanelDesc(this.clickedRepeatItem, layout.mainDataSource.activeRow?.data?.service_name);
                        } else if ((OpenSliderFrom.MOBILE_COMMUNICATION_AND_HOS_SERVICE === sliderFrom || OpenSliderFrom.TEMPERATURE_AND_TRAILER_TRACKING === sliderFrom)
                            && this.clickedRepeatItem) {

                            let mcShowSwitch = null;
                            if (OpenSliderFrom.MOBILE_COMMUNICATION_AND_HOS_SERVICE === sliderFrom)
                                mcShowSwitch = this.mobileCommHOSSwitch;
                            else if (OpenSliderFrom.TEMPERATURE_AND_TRAILER_TRACKING === sliderFrom)
                                mcShowSwitch = this.mobileCommTrackingSwitch;

                            this.updateIsActiveImage(this.clickedRepeatItem, isActiveVendor);
                            this.updatePanelDesc(this.clickedRepeatItem, layout.mainDataSource.activeRow?.data?.vendor_name);
                            this.clickedRepeatItem.boundRow.set("is_active", layout.mainDataSource.activeRow.get("is_active"));
                            this.clickedRepeatItem.visible = !mcShowSwitch.checked || isActiveVendor;

                            // Check if any mobile comm items are active after this save
                            const hasActiveItems = this.mobileCommItems.some(item => {
                                const itemIsActive = item.boundRow?.data?.is_active === "Y" || item.boundRow?.data?.is_active === true;
                                return itemIsActive;
                            });

                            // If no active items exist, set switch to unchecked and show all items
                            if (!hasActiveItems && mcShowSwitch) {
                                mcShowSwitch.checked = false;
                                mcShowSwitch = false;
                                const itemsContainer = this.findComponentById(`items-container-Mobile Communications and Hours of Service`) as Panel;
                                if (itemsContainer) {
                                    this.updateMobileCommItemsVisibility(itemsContainer, false);
                                }
                            }

                            if (OpenSliderFrom.MOBILE_COMMUNICATION_AND_HOS_SERVICE === sliderFrom && this.clickedRepeatItem) {
                                const itemsContainer = this.findComponentById(`items-container-Trailer and Temperature Tracking`) as Panel;
                                if (itemsContainer) {
                                    for (const component of itemsContainer.components) {
                                        if (this.isRepeatItem(component)) {
                                            const clickedctualVendorId = this.clickedRepeatItem.boundRow?.get("actual_vendor_id");
                                            const actualVendorId = component.boundRow?.get("actual_vendor_id");
                                            if (clickedctualVendorId === actualVendorId) {
                                                this.updateIsActiveImage(component, isActiveVendor);
                                                this.updatePanelDesc(component, layout.mainDataSource.activeRow?.data?.vendor_name);
                                                component.visible = this.clickedRepeatItem.visible;
                                                break;
                                            }
                                        }
                                    }
                                }
                            }

                            if (OpenSliderFrom.TEMPERATURE_AND_TRAILER_TRACKING === sliderFrom && this.clickedRepeatItem) {
                                const itemsContainer = this.findComponentById(`items-container-Mobile Communications and Hours of Service`) as Panel;
                                if (itemsContainer) {
                                    for (const component of itemsContainer.components) {
                                        if (this.isRepeatItem(component)) {
                                            const clickedctualVendorId = this.clickedRepeatItem.boundRow?.get("actual_vendor_id");
                                            const actualVendorId = component.boundRow?.get("actual_vendor_id");
                                            if (clickedctualVendorId === actualVendorId) {
                                                this.updateIsActiveImage(component, isActiveVendor);
                                                this.updatePanelDesc(component, layout.mainDataSource.activeRow?.data?.vendor_name);
                                                component.visible = this.clickedRepeatItem.visible;
                                                break;
                                            }
                                        }
                                    }
                                }
                            }

                        } else if (OpenSliderFrom.CARRIER_MONITORING === sliderFrom && this.clickedRepeatItem) {
                            const parentPanel = this.clickedRepeatItem.parent;
                            parentPanel.components.forEach(item => this.updateIsActiveImage(item, false));
                            this.updateIsActiveImage(this.clickedRepeatItem, isActiveVendor);
                        }
                    }
                    saveButton.busy = false;
                }
            });

            const deleteButton = new Button({ themeKey: "editRowDecorator.deleteButton", id: "erdDeleteButton", rowBreak: false, visible: false });
            if (OpenSliderFrom.MOBILE_COMMUNICATION_AND_HOS_SERVICE === sliderFrom || OpenSliderFrom.TEMPERATURE_AND_TRAILER_TRACKING === sliderFrom) {
                // Adding to eliminate multiple slide outs when user clicks multiple times
                // If there is a better way to handle this, please let me know
                if (!this.slideoutOpening) {
                    this.slideoutOpening = true;

                    setTimeout(() => {
                        this.slideoutOpening = false;
                    }, 200);
                } else {
                    return;
                }

                if (vendorId) {
                    const searchFilters = { id: vendorId };
                    await layout.mainDataSource.search(searchFilters);
                }
                layout.mainDataSource.mode = await layout.activeRow ? DataSourceMode.UPDATE : DataSourceMode.ADD;

                const crud = new CrudDecorator({
                    layout: layout,
                    headerProps: {
                        showClose: true,
                        showSaveAndClose: true,
                        showDelete: false,
                        onExecute: () => {
                            if (this.clickedRepeatItem) {
                                // Doing this so display a new title if vendor_name is changed
                                // Looking for a better way to do this
                                layout.mainDataSource.mode =  DataSourceMode.NONE;
                                layout.mainDataSource.mode = StringUtil.isEmptyString(vendorId) ? DataSourceMode.ADD : DataSourceMode.UPDATE;
                            }

                            this.saveButtonClicked = true;
                        },
                    },
                    doAfterSlideIn: async () => {
                        layout.mainDataSource.mode = StringUtil.isEmptyString(vendorId) ? DataSourceMode.ADD : DataSourceMode.UPDATE;
                    },
                    doAfterSlideOut: async () => {
                        if (this.saveButtonClicked) {
                            if (StringUtil.isEmptyString(vendorId)) {
                                Navigation.reloadCurrentPage(false);
                            }

                            const isActiveVendor = layout.mainDataSource.activeRow?.data?.is_active === "Y";
                            const vendorName = layout.mainDataSource.activeRow?.data?.vendor_name;
                            const mcShowSwitch = this.getMobileCommSwitch(sliderFrom);

                            this.updateVendorItem(this.clickedRepeatItem, isActiveVendor, vendorName, layout.mainDataSource.activeRow.get("is_active"));
                            this.clickedRepeatItem.visible = !mcShowSwitch?.checked || isActiveVendor;

                            this.handleInactiveItemsCheck(mcShowSwitch);
                            this.updateCrossContainerVendorItem(sliderFrom, isActiveVendor, vendorName);
                        }
                        this.saveButtonClicked = false;
                    }
                });
                crud.slideIn({ speed: 200, direction: Alignment.BOTTOM });
            } else {
                const editRowDecorator = new EditRowDecorator({
                    title: title,
                    layout: layout,
                    fillVerticalSpace: true,
                    overlayProps: {
                        greyedBackground: true,
                        closeOnClickOff: false,
                        closeHandler: async () => this.validateUnSaveChanges(layout)
                    },
                    addlComponents: [saveButton, deleteButton],
                    onClose: () => this.validateUnSaveChanges(layout),
                    doAfterSlideIn: async () => {
                        layout.mainDataSource.mode = StringUtil.isEmptyString(vendorId) ? DataSourceMode.ADD : DataSourceMode.UPDATE;
                        layout.mainDataSource.addHasChangedComponent(saveButton);

                        let searchFilters;
                        if (sliderFrom === OpenSliderFrom.LOADBOARD_SERVICE) {
                            searchFilters = { service_type: vendorId, description: this.descriptionName };
                        } else if (sliderFrom === OpenSliderFrom.LOADBOARD_SERVICE_SEARCH) {
                            searchFilters = { posting_format: vendorId, service_type: "%T%" };
                        } else {
                            searchFilters = { vendor: vendorId };
                        }

                        if (!StringUtil.isEmptyString(vendorId)) {
                            await layout.mainDataSource.search(searchFilters).then(() => {
                                layout.mainDataSource.mode = layout.activeRow ? DataSourceMode.UPDATE : DataSourceMode.ADD;
                                if (OpenSliderFrom.DAT === sliderFrom) {
                                    const isRateViewEnabled = layout.mainDataSource.activeRow?.data?.dat_rateview_enabled === true;
                                    if (isRateViewEnabled) {
                                        layout.sourceLmeUserToken.notifyHasChangedComponents(true);
                                    }
                                }
                            });
                        }
                        layout.mainDataSource.mode = layout.activeRow ? DataSourceMode.UPDATE : DataSourceMode.ADD;
                        layout.mainDataSource.notifyHasChangedComponents(false);
                        saveButton.dataSource = null;

                        await this.searchAdditionalDatasources(sliderFrom, layout, vendorId, saveButton);
                    }
                });
            }
        });
    }


    private configureSmsLayout(layout: any) {
        if (!StringUtil.isEmptyString(layout?.activeRow?.get("web_username"))
            && !StringUtil.isEmptyString(layout?.activeRow?.get("web_password"))
            && !StringUtil.isEmptyString(layout?.activeRow?.get("callback_url"))
            && !StringUtil.isEmptyString(layout?.activeRow?.get("sender_id"))
            && (StringUtil.isEmptyString(layout?.activeRow?.get("site_id"))
                || StringUtil.isEmptyString(layout?.activeRow?.get("application_id"))
                || StringUtil.isEmptyString(layout?.activeRow?.get("location_id")))) {
            layout.buttonInitializeAccount.visible = true;
            layout.textboxSiteId.enabled = false;
            layout.textboxApplicationId.enabled = false;
            layout.textboxLocationId.enabled = false;
            layout.textboxSiteId.required = false;
            layout.textboxApplicationId.required = false;
            layout.textboxLocationId.required = false;
        }
    }

    private async configureExportAndExchangeLayouts(layout: any, vendor: string, sliderFrom: string, saveButton: SaveButton) {
        layout.width = 1400;
        layout.sourceMarketrateExprt.mode = DataSourceMode.UPDATE;

        // Perform the search and update mode if no active row is found
        await layout.sourceMarketrateExprt.search({ "vendor": vendor }).then(() => {
            if (layout.sourceMarketrateExprt.activeRow == null) {
                layout.sourceMarketrateExprt.mode = DataSourceMode.ADD;
            }
        });
        if (OpenSliderFrom.MPACT === sliderFrom) {
            await layout.sourceExchangeControl.search();
            layout.sourceExchangeControl.addHasChangedComponent(saveButton);
        }
        layout.sourceMarketrateExprt.addHasChangedComponent(saveButton);
    }

    private async searchAdditionalDatasources(sliderFrom: OpenSliderFrom, layout: any, vendorId: string, saveButton: SaveButton) {
            if (OpenSliderFrom.DAT === sliderFrom || OpenSliderFrom.GREENSCREENS === sliderFrom || OpenSliderFrom.MPACT === sliderFrom) {
            const vendor = OpenSliderFrom.MPACT === sliderFrom ? "M" : vendorId;
            await this.configureExportAndExchangeLayouts(layout, vendor, sliderFrom, saveButton)
        } else if (OpenSliderFrom.BROKERAGE_TRACKING === sliderFrom) {
            await layout.sourceBrTrackingDocTypeMap.search({ "vendor_id": vendorId });
        } else if (OpenSliderFrom.CARRIER_MONITORING === sliderFrom) {
            if (StringUtil.equalsIgnoreCase(vendorId, "H")) {
                await layout.sourceInterfaceCodes.search({ "code_type": "HWE" });
            } else if (StringUtil.equalsIgnoreCase(vendorId, "D")) {
                await layout.sourceInterfaceCodes.search({ "code_type": "AAE" });
            }
        } else if (OpenSliderFrom.CARRIER_PERFORMANCE === sliderFrom) {
            await layout.sourceInterfaceCodes.search({ "code_type": "ISO" });
        } else if (OpenSliderFrom.LOADBOARD_SERVICE === sliderFrom) {
            layout.sourceDispatchControl.addHasChangedComponent(saveButton);
        }
    }

    dataListOnItemDisplay(event: RepeatItemDisplayEvent) {
        const dataListItem = event.getRepeatItem();
        const category = dataListItem.boundRow?.get("category");
        const parentPanel = this.findComponentById("panelIntegrationsContainer") as Panel;

        // Reset mobile comm tracking when starting a new data load
        if (!this.currentLabelHeader) {
            this.mobileCommItems = [];
            this.mobileCommTrackingItems = [];
            this.mobileCommHOSSwitch = null;
            this.mobileCommTrackingSwitch = null;
            if (this.configureTimeoutId) {
                clearTimeout(this.configureTimeoutId);
                this.configureTimeoutId = null;
            }
        }

        if (!this.currentLabelHeader || !StringUtil.equalsIgnoreCase(this.currentLabelHeader, category)) {
            this.addCategoryDivider(category, parentPanel);
        }

        const currentItemsContainer = this.findComponentById(`items-container-${category}`) as Panel;
        if (currentItemsContainer) {
            this.setDataListItemVisibility(dataListItem);
            currentItemsContainer.add(dataListItem);
        }

        // Track mobile comm items
        if (category === "Mobile Communications and Hours of Service") {
            this.mobileCommItems.push(dataListItem);
            // Debounce the configuration call to ensure it runs only after all items are processed
            if (this.configureTimeoutId) {
                clearTimeout(this.configureTimeoutId);
            }
            const itemsContainer = this.findComponentById(`items-container-Mobile Communications and Hours of Service`) as Panel;
            this.configureTimeoutId = setTimeout(() => this.configureMobileCommSwitch(this.mobileCommHOSSwitch, this.mobileCommItems, itemsContainer), 0);
        }

        if (category === "Trailer and Temperature Tracking") {
            this.mobileCommTrackingItems.push(dataListItem);
            // Debounce the configuration call to ensure it runs only after all items are processed
            if (this.configureTimeoutId) {
                clearTimeout(this.configureTimeoutId);
            }
            const itemsContainer = this.findComponentById(`items-container-Trailer and Temperature Tracking`) as Panel;
            this.configureTimeoutId = setTimeout(() => this.configureMobileCommSwitch(this.mobileCommTrackingSwitch, this.mobileCommTrackingItems, itemsContainer), 0);
        }

        this.processCategory(category, dataListItem, event.getRepeatItem());
    }

    private addCategoryDivider(category: string, parentPanel: Panel) {
        if (this.currentLabelHeader) {
            parentPanel.add(new Label({
                id: `divider-${category}`,
                marginTop: 8,
                marginBottom: 8,
                fillRow: true,
                borderTopWidth: 1,
                borderTopColor: "subtle.light",
                padding: 0
            }));
        }

        const categorySection = new Panel({
            id: `category-section-${category}`,
            verticalAlign: VerticalAlignment.TOP,
            paddingLeft: 16
        });

        const itemsContainer = new Panel({
            id: `items-container-${category}`,
            fillRow: true,
            rowBreakDefault: false,
            paddingLeft: 16
        });

        const categoryLabel = new Label({
            text: category,
            variant: LabelVariant.sectionHeading,
            paddingTop: 8,
            paddingBottom: 8
        });
        categorySection.add(categoryLabel);

        if (category === "Mobile Communications and Hours of Service" || category === "Trailer and Temperature Tracking") {
            categoryLabel.rowBreak = false;
            categoryLabel.paddingBottom = 25;

            const switchShowMC = new Switch({
                leftCaption: "All",
                rightCaption: "Active",
                color: "subtle.darker",
                paddingLeft: 36,
                paddingBottom: 25,
                onClick: () => {
                    //                    this.showMC = switchShowMC.checked;
                    this.handleMobileCommSwitchToggle(category, switchShowMC.checked);
                },
                checked: false, // Start unchecked, will be updated based on data
                marginRight: 48
            });

            // Store reference to the switch for later updates
            if (category === "Mobile Communications and Hours of Service")
                this.mobileCommHOSSwitch = switchShowMC;
            else if (category === "Trailer and Temperature Tracking")
                this.mobileCommTrackingSwitch = switchShowMC;

            categorySection.add(switchShowMC);
        }

        categorySection.add(itemsContainer);
        parentPanel.add(categorySection);

        this.currentLabelHeader = category;
    }

    private processCategory(category: string, dataListItem: RepeatItem, repeatItem: RepeatItem) {
        const categoryMapping = {
            "Shipment Visibility": "labelBrokerageTracking",
            "Carrier Monitoring & Onboarding": "labelCarrierMonitoring",
            "Rating & Pricing": "labelRatingAndPricing",
            "Carrier Performance": "labelScorecard",
            "Mapping & Distance": "labelMappingAndDistance",
            "Messaging & Communications": "labelSmsTextMessaging",
            "LTL": "labelLtl",
            "Load Board Services": "labelLoadBoardService",
            "Mobile Communications and Hours of Service": "labelMobileCommunicationsAndHoursOfService",
            "Trailer and Temperature Tracking": "labelTemperatureAndTrailerTracking",
            "Freight Matching": "labelFreightMatching",
            "Carrier Invoices & Payments" : "labelPaymentServices",
            "Fuel" : "labelFuelServices",
            "Benchmarking & Analysis" : "labelBenchmarkingReports"
        };

        if (categoryMapping[category]) {
            this.showLabel(dataListItem, categoryMapping[category]);
            this.processDataListItem(repeatItem, category);
        } else {
            dataListItem.visible = false;
            dataListItem.enabled = false;
        }
    }

    private showLabel(dataListItem: any, labelId: string) {
        const categoryLabel = dataListItem.parent.parent.findComponentById(labelId) as Label;
        if (categoryLabel) {
            categoryLabel.visible = true;
        }
    }

    processDataListItem(item: RepeatItem, category: string) {
        const dataListItem = item;
        const panelImage = dataListItem.findComponentById("panelImage") as Panel;

        const imageSrc = this.getImageSource(dataListItem);
        const imageByte = dataListItem.boundRow?.get("image_bytes");
        const clickEventId = dataListItem.boundRow?.get("click_event_id");
        const isActive = dataListItem.boundRow?.get("is_active");

        if (panelImage && (!StringUtil.isEmptyString(imageSrc) || !StringUtil.isEmptyString(imageByte))) {
            this.addImageToPanel(dataListItem, panelImage, imageSrc, imageByte, clickEventId);
        } else {
            this.createAddServiceButtonPanel(dataListItem);
        }
        this.setupClickListeners(dataListItem, clickEventId);
        this.updateIsActiveImage(dataListItem, isActive);
        this.setUpMouseEvents(dataListItem);
        this.handleUrlProps(dataListItem, category);
    }

    createAddServiceButtonPanel(dataListItem: RepeatItem) {
        const panelImage = dataListItem.findComponentById("panelImage") as Panel;
        const panelContent = dataListItem.findComponentById("panelContent") as Panel;
        const clickEventId = dataListItem.boundRow?.get("click_event_id");
        const panelCategory = dataListItem.findComponentById("panelCategory") as Panel;
        const addButton = new Button({
            rowBreak: false,
            imageName: ImageName.add,
            backgroundColor: "primary",
            color: "primary.reverse",
            caption: "Add Service",
            borderWidth: 0,
            borderColor: "primary",
            margin: "auto",
            marginTop: "45%",
            onClick: (event) => {
                this.determineClickEvent(clickEventId, event, dataListItem, true);
                this.clickedRepeatItem = dataListItem;
            }
        });
        panelImage.visible = false;
        panelCategory.visible = false;
        panelContent.visible = false;
        dataListItem.add(addButton);
        dataListItem.borderColor = "primary.light";
        dataListItem.backgroundColor = "primary.lightest";
        dataListItem.borderType = BorderType.DASHED;
        dataListItem.borderWidth = 1;
    }


    getImageSource(dataListItem: any): string {
        let imageSrc = dataListItem.boundRow?.get("image");

        if (!StringUtil.isEmptyString(imageSrc) && imageSrc instanceof ArrayBuffer) {
            imageSrc = this.arrayBufferToBase64(imageSrc);
        }

        return imageSrc;
    }

    addImageToPanel(repeatItem: RepeatItem, panelImage: Panel, imageSrc: string, imageByte: string, clickEventId: number) {
        const id = clickEventId?.toString();
        const image = new Image({
            id,
            imageType: ImageType.IMG,
            width: 250,
            height: 150,
            preserveAspectRatio: true,
            onClick: (event) => {
                this.determineClickEvent(clickEventId, event, repeatItem);
                this.clickedRepeatItem = repeatItem;
            }
        });

        if (!StringUtil.isEmptyString(imageSrc)) {
            image._element.setAttribute("src", imageSrc);
        } else if (!StringUtil.isEmptyString(imageByte)) {
            // Check if this is an SVG by decoding the first few bytes
            const isSvg = this.isSvgImage(imageByte);
            if (isSvg) {
                // For SVG, use the correct MIME type
                image._element.setAttribute("src", "data:image/svg+xml;base64," + imageByte);
            } else {
                image.imageBytes = imageByte;
            }
        }

        panelImage.add(image);
    }

    /**
     * Checks if a base64-encoded image is an SVG by looking at the decoded content.
     * SVG files typically start with "<?xml" or "<svg" or whitespace followed by those.
     */
    private isSvgImage(base64String: string): boolean {
        try {
            // Decode the first 100 characters to check for SVG markers
            const decoded = atob(base64String.substring(0, 200));
            const trimmed = decoded.trim().toLowerCase();
            return trimmed.startsWith("<?xml") || trimmed.startsWith("<svg") || trimmed.includes("<svg");
        } catch (e) {
            return false;
        }
    }

    setupClickListeners(dataListItem: any, clickEventId: number) {
        const panelCategory = dataListItem.findComponentById("panelCategory") as Panel;
        const clickHandler = (event) => {
            event.target.id = `${clickEventId}`;
            this.determineClickEvent(clickEventId, event, dataListItem);
            this.clickedRepeatItem = dataListItem;
        };
        panelCategory.addClickListener(clickHandler);
    }


    updateIsActiveImage(dataListItem: any, isActive: boolean) {
        const panelActiveContainer = dataListItem.findComponentById("panelActiveContainer") as Panel;
        const isActiveImage = dataListItem.findComponentById("imageActive") as Image;
        const labelActiveDesc = dataListItem.findComponentById("labelActiveDesc") as Label;
        isActiveImage.name = isActive ? ImageName.activeCircle : ImageName.inactiveCircle;
        isActiveImage.color = isActive ? "success" : "subtle.light";
        labelActiveDesc.text = isActive ? "Active" : "Inactive";
        labelActiveDesc.color = isActive ? "success" : "subtle.light";
        panelActiveContainer.borderColor = isActive ? "success" : "subtle.light";
    }

    updatePanelDesc(clickedRepeatItem: RepeatItem, description: any) {
        const nameLabel = clickedRepeatItem.findComponentById("labelName") as Label;
        if (!StringUtil.isEmptyString(description)) {
            nameLabel.text = description;
        }
    }

    setUpMouseEvents(dataListItem: any) {
        // Adding mouse enter listener to simulate the raised effect
        dataListItem.addMouseEnterListener(event => {
            const target = event.target;
            // Apply uniform shadow on all sides
            target.style.boxShadow = "0px 0px 12px rgba(0, 0, 0, 0.2)";  // Shadow on all sides
            target.style.transform = "scale(1.05)";  // Slight scaling for a raised effect
            target.style.transition = "transform 0.2s ease, box-shadow 0.2s ease"; // Smooth transition
        });

        // Adding mouse leave listener to remove the raised effect
        dataListItem.addMouseLeaveListener(event => {
            const target = event.target;
            target.style.boxShadow = "none";  // Removing shadow when mouse leaves
            target.style.transform = "scale(1)";  // Reset scaling
            target.style.transition = "transform 0.2s ease, box-shadow 0.2s ease";
        });
    }

    handleUrlProps(dataListItem: RepeatItem, category: string) {
        const urlProps = UrlUtil.getPropsFromUrl(window.location.search);
        if (category == Categories.FUEL_CATEGORY) {
            if (urlProps?.fuelVendor && dataListItem.boundRow?.get("fuel_vendor_id") == urlProps.fuelVendor) {
                const image = dataListItem.findComponentByType(Image) as Image;
                image.clicked();
            }
        }
    }

    private arrayBufferToBase64(buffer: ArrayBuffer, mimeType = 'image/png'): string {
        if (!buffer || !(buffer instanceof ArrayBuffer)) {
            throw new Error("Invalid input: expected an ArrayBuffer.");
        }

        const bytes = new Uint8Array(buffer);
        const len = bytes.byteLength;
        let binary = '';

        for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }

        const base64String = window.btoa(binary);
        return `data:${mimeType};base64,${base64String}`;
    }


    determineClickEvent(clickEventId: number, event: ClickEvent, dataListItem: any, appending: boolean = false) {
        const nameLabel = dataListItem.findComponentById("labelName") as Label;
        this.descriptionName = nameLabel.text;

        const actualVendorId = dataListItem.boundRow?.get("actual_vendor_id");
        if (this.sliderConfiguration[clickEventId]) {
            this.showIntegrationSlideout(event, clickEventId, actualVendorId);
        } else {
            const partnerType = dataListItem.boundRow?.get("mobile_comm_type");
            const category = dataListItem.boundRow?.get("category");
            if (partnerType === "MC_HOS_TYPE") {
                this.setUpControlLayout(actualVendorId, SliderTitle.MOBILE_COMMUNICATION_CONTROL, OpenSliderFrom.MOBILE_COMMUNICATION_AND_HOS_SERVICE, null, dataListItem);
            } else if (partnerType === "MC_TRACKING_TYPE") {
                this.setUpControlLayout(actualVendorId, SliderTitle.MOBILE_COMMUNICATION_CONTROL, OpenSliderFrom.TEMPERATURE_AND_TRAILER_TRACKING, null, dataListItem);
            } else if (StringUtil.equalsIgnoreCase(category, Categories.PAYMENT_CATEGORY)
                || StringUtil.equalsIgnoreCase(category, Categories.SMS_CATEGORY)
                || StringUtil.equalsIgnoreCase(category,Categories.BENCHMARK_REPORTS_CATEGORY)
                || StringUtil.equalsIgnoreCase(category, Categories.lOADBOARD_CATEGORY)){
                this.setupCrudDecorator(dataListItem, appending, null, {
                    doAfterSlideOut: async (decorator: CrudDecorator) => {
                        const layout = decorator.layout;
                        let isActive = layout.mainDataSource.activeRow?.get("is_active");
                        if (isActive === true) isActive = "Y";
                        if (isActive === false || layout.mainDataSource.activeRow._appending) isActive = "N";
                        this.updateIsActiveImage(this.clickedRepeatItem, StringUtil.equalsIgnoreCase(isActive,"Y"));
                    }
                });
            } else if (StringUtil.equalsIgnoreCase(category, Categories.FUEL_CATEGORY)) {
                const vendorId = dataListItem.boundRow?.get("fuel_vendor_id");
                const vendorName = !StringUtil.isEmptyString(dataListItem.boundRow?.get("name")) ? dataListItem.boundRow?.get("name") : "New";
                this.setupCrudDecorator(dataListItem, appending, { "fuel_interface_id": vendorId }, {
                    headerProps: {
                        title: `Fuel Services Provider Control - ${vendorName}`,
                    },
                    doAfterSlideOut: async (decorator: CrudDecorator) => {
                        const layout = decorator.layout as FuelFundedVendorDefaults;
                        const foundActive = this.isFuelVendorActive(layout.tableFundedVendors.data);
                        this.updateIsActiveImage(this.clickedRepeatItem, foundActive);
                    }
                });
            }
        }
    }

    private async setupCrudDecorator(dataListItem: any, appending: boolean, searchFilter = {}, decoratorProps?: Partial<CrudDecoratorProps>) {
        try {
            const modelRow = dataListItem?.boundRow;
            const layout = Layout.getLayout(modelRow.get("layout"));
            const existing = modelRow.getBoolean("existing_record", false);
            if (!modelRow.isNull("existing_record") && !appending && !existing) {
                appending = true; // if tile existed prev but had no existing record, it should be ADD mode
            }
            const datasourceMode = !appending ? DataSourceMode.UPDATE : DataSourceMode.ADD;

            const crudPanel = new CrudDecorator({
                layout: layout,
                mode: datasourceMode,
                layoutLoadListeners: () => {
                    if (!appending) {
                        layout.mainDataSource?.search(searchFilter);
                    }
                    layout.mainDataSource?.addBeforeModeChangeListener((event: DataSourceModeChangeEvent) => {
                        if (event.oldMode === DataSourceMode.ADD && event.newMode === DataSourceMode.UPDATE) {
                            modelRow?.set("existing_record", true);
                        }
                    });

                    if (typeof (layout as any).doAfterSlideIn === "function") {
                        (layout as any).doAfterSlideIn();
                    }

                    const isActiveVendor = layout.mainDataSource?.activeRow?.data?.is_active === "Y";
                    this.updateIsActiveImage(this.clickedRepeatItem, isActiveVendor);
                },
                ...decoratorProps
            });

            await crudPanel.slideIn({speed: 200, direction: Alignment.BOTTOM});
        } catch (error) {
            Snackbar.showWarningSnackbar(`Error loading configuration: ${error.message || 'Unknown error'}`);
        }
    }

    showIntegrationSlideout(event: ClickEvent, clickEventId: number, actualVendorId?: string) {
        const config = this.sliderConfiguration[clickEventId];
        if (config) {
            const vendorIdForSlider = actualVendorId || config.vendorId;
            if (config.isSingleton === undefined) {
                this.setUpControlLayout(vendorIdForSlider, config.title, config.openFrom, config.childSection);
            } else {
                this.setupSingleControlLayout(vendorIdForSlider, config.sliderTitle, config.sliderFrom, config.isSingleton, config.childSection);
            }
        }
    }

    /**
     * Gets the mobile communication switch based on the slider source
     */
    private getMobileCommSwitch(sliderFrom: OpenSliderFrom): any {
        if (OpenSliderFrom.MOBILE_COMMUNICATION_AND_HOS_SERVICE === sliderFrom) {
            return this.mobileCommHOSSwitch;
        } else if (OpenSliderFrom.TEMPERATURE_AND_TRAILER_TRACKING === sliderFrom) {
            return this.mobileCommTrackingSwitch;
        }
        return null;
    }

    /**
     * Updates vendor item with active status, description, and data
     */
    private updateVendorItem(repeatItem: any, isActiveVendor: boolean, vendorName: string, isActiveValue: any): void {
        if (!repeatItem) return;

        this.updateIsActiveImage(repeatItem, isActiveVendor);
        this.updatePanelDesc(repeatItem, vendorName);
        repeatItem.boundRow.set("is_active", isActiveValue);
    }

    /**
     * Handles checking for inactive items and updating switch state
     */
    private handleInactiveItemsCheck(mcShowSwitch: any): void {
        if (!mcShowSwitch) return;

        // Check if any mobile comm items are active after this save
        const hasActiveItems = this.mobileCommItems.some(item => {
            const itemIsActive = item.boundRow?.data?.is_active === "Y" || item.boundRow?.data?.is_active === true;
            return itemIsActive;
        });

        // If no active items exist, set switch to unchecked and show all items
        if (!hasActiveItems) {
            mcShowSwitch.checked = false;
            const itemsContainer = this.findComponentById(`items-container-Mobile Communications and Hours of Service`) as Panel;
            if (itemsContainer) {
                this.updateMobileCommItemsVisibility(itemsContainer, false);
            }
        }
    }

    /**
     * Updates the corresponding vendor item in the other container (cross-container sync)
     */
    private updateCrossContainerVendorItem(sliderFrom: OpenSliderFrom, isActiveVendor: boolean, vendorName: string): void {
        if (!this.clickedRepeatItem) return;

        const targetContainerName = this.getTargetContainerName(sliderFrom);
        if (!targetContainerName) return;

        const itemsContainer = this.findComponentById(`items-container-${targetContainerName}`) as Panel;
        if (!itemsContainer) return;

        const clickedVendorId = this.clickedRepeatItem.boundRow?.get("actual_vendor_id");

        for (const component of itemsContainer.components) {
            if (this.isRepeatItem(component)) {
                const actualVendorId = component.boundRow?.get("actual_vendor_id");
                if (clickedVendorId === actualVendorId) {
                    this.updateIsActiveImage(component, isActiveVendor);
                    this.updatePanelDesc(component, vendorName);
                    component.visible = this.clickedRepeatItem.visible;
                    break;
                }
            }
        }
    }

    /**
     * Gets the target container name for cross-container updates
     */
    private getTargetContainerName(sliderFrom: OpenSliderFrom): string | null {
        switch (sliderFrom) {
            case OpenSliderFrom.MOBILE_COMMUNICATION_AND_HOS_SERVICE:
                return "Trailer and Temperature Tracking";
            case OpenSliderFrom.TEMPERATURE_AND_TRAILER_TRACKING:
                return "Mobile Communications and Hours of Service";
            default:
                return null;
        }
    }

    /**
     * Checks if any fuel vendor record meets the criteria for being active.
     * For local: active if file path (remote_directory) is set.
     * For internet: active if login, password, ip_address (URL), and port are set.
     */
    private isFuelVendorActive(fundedVendorData: ModelRow[]): boolean {
        const fuelRows = fundedVendorData;
        if (fuelRows) {
            return fuelRows.some(row => {
                const connectionType = row.get("communication_type")?.toLowerCase();
                if (connectionType === "local") {
                    return !row.isNull("remote_directory");
                } else {
                    return !row.isNull("provider_login") &&
                        !row.isNull("host_password") &&
                        !row.isNull("ip_address");
                }
            });
        }
        return false;
    }

}
